import { Box } from '@jfs/ui-new'
import { ReactElement } from 'react'
import EmptyView from '../../comps/EmptyView'
import { NewTable } from '../../comps/NewTable'
import { bulkRefundTitleData } from '../../data/static/data'
import { transactionScreenStrings } from '../../data/static/strings'
import { getCustomColumnWidth, tableConfig, useWindowDimensions } from '../../util/util'

const SVTable = ({ scrollStyle, listData, onPress, path, hide, headerRowKeys, onItemAction }: any): ReactElement => {
  const viewPortWidth = useWindowDimensions()
  return (
    <Box {...scrollStyle}>
      <NewTable
        data={listData}
        rowHeight={48}
        headerHeight={64}
        onAction={onItemAction}
        customWidthFunc={getCustomColumnWidth}
        freezeColumn="fileName"
        height={546}
        tableWidth={viewPortWidth > 1200 ? viewPortWidth - 588 : viewPortWidth}
        headerRowKeys={headerRowKeys}
        transactionType={tableConfig(path).status}
        onRowClick={onPress}
        hide={hide}
        sortBy="fileName"
        freezeColumnWidth={300}
      />
    </Box>
  )
}

interface RefundsListProps {
  onRetry: any
  loadingState: any
  errorState: any
  emptyState: any
  scrollStyle: any
  listData: any
  onPress: any
  path: any
  fieldSettingVisible: any
  filterVisible: any
  onFileDownloadClick: any
}

const RefundsList = ({
  onRetry,
  loadingState,
  errorState,
  emptyState,
  scrollStyle,
  listData,
  onPress,
  path,
  fieldSettingVisible,
  filterVisible,
  onFileDownloadClick,
}: RefundsListProps) => {
  return (
    <>
      <EmptyView
        onRetry={onRetry}
        isLoading={loadingState}
        error={errorState}
        emptyMessage={'No Data Found...'}
        loadingMessage={transactionScreenStrings.loading}
        hide={emptyState}
      />
      <SVTable
        scrollStyle={scrollStyle}
        listData={listData}
        onPress={onPress}
        path={path}
        headerRowKeys={bulkRefundTitleData}
        onItemAction={onFileDownloadClick}
        hide={listData.length === 0 || fieldSettingVisible || filterVisible || !(!loadingState && !errorState)}
      />
    </>
  )
}

export { RefundsList }
